<template>
  <transition name="path-fade">
    <svg
      v-if="direction"
      class="shape-path"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        v-if="sides.top"
        x1="12"
        y1="0"
        x2="12"
        y2="12"
        v-bind="lineAttrs"
      />
      <line
        v-if="sides.bottom"
        x1="12"
        y1="12"
        x2="12"
        y2="24"
        v-bind="lineAttrs"
      />
      <line
        v-if="sides.left"
        x1="0"
        y1="12"
        x2="12"
        y2="12"
        v-bind="lineAttrs"
      />
      <line
        v-if="sides.right"
        x1="12"
        y1="12"
        x2="24"
        y2="12"
        v-bind="lineAttrs"
      />
    </svg>
  </transition>
</template>

<script>
import { DIRECTION_SIDES, PATH_WEIGHTS } from './ShapeModel';

export default {
  name: 'shape-path',
  props: {
    direction: { type: String, default: null },
    color: { type: String, default: '#000000' },
    pathWeight: { type: String, default: 'normal' },
  },
  computed: {
    sides() {
      return DIRECTION_SIDES[this.direction] || {};
    },
    lineAttrs() {
      return {
        stroke: this.color,
        'stroke-width': PATH_WEIGHTS[this.pathWeight],
        'stroke-linecap': 'round',
      };
    },
  },
};
</script>

<style scoped>
.shape-path {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.path-fade-enter-active,
.path-fade-leave-active {
  transition: opacity 0.3s ease;
}
.path-fade-enter,
.path-fade-leave-to {
  opacity: 0;
}
</style>
